"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Client = _interopRequireDefault(require("./Client"));

/**
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2018 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Inc. and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe Inc.
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Inc.
 */

/**
 * The Resources class handles listing Resources data (i.e. resources shared with a user) for a specific user.
 */
var Resources = /*#__PURE__*/function () {
  function Resources() {
    (0, _classCallCheck2["default"])(this, Resources);
  }

  (0, _createClass2["default"])(Resources, [{
    key: "get",

    /**
     * Get the resources shared with the user.
     * @param {Object} options - (optional) Sorting and filtering options, as listed below
     *
     *        {String} orderBy - (optional, default = "+sharedate") Field to sort on, and direction. E.g. "+sharedate"
     *                           for sorting by date shared ascending. Prefix with "-" for descending.
     *        {String[]} types - (optional) A list of mime-types to filter by. If none provided, all mimetypes will be
     *                           returned.
     * @returns {Promise}
     */
    value: function get() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$orderBy = _ref.orderBy,
          orderBy = _ref$orderBy === void 0 ? '+sharedate' : _ref$orderBy,
          _ref$types = _ref.types,
          types = _ref$types === void 0 ? [] : _ref$types,
          _ref$limit = _ref.limit,
          limit = _ref$limit === void 0 ? 10 : _ref$limit;

      // NOTE: /resources/ will redirect to /resources, which messes up UXP clients.
      return _Client["default"].instance.fetch({
        type: 'resources.get',
        urlPath: "/resources?orderBy=".concat(encodeURIComponent(orderBy), "&type=").concat(encodeURIComponent(types.join(',')), "&limit=").concat(limit)
      });
    }
    /**
     * Get the next page of resources results, using the URL from Resources.get().
     * @param urlPath {String} URL from Resources.get(), from the _links.next property of the response.
     * @returns {Promise|*|Promise<Response>}
     */

  }, {
    key: "getNextPage",
    value: function getNextPage(urlPath) {
      return _Client["default"].instance.fetch({
        type: 'resources.get',
        urlPath: urlPath
      });
    }
  }]);
  return Resources;
}();
/**
 * Exports the Resources class.
 */


var _default = Resources;
exports["default"] = _default;